import React, { useState, useEffect } from 'react';
import { CONTENT_GRID_CARDS } from 'constants/contentGrid';
import {
  CONTENT, CONTENT_CONTAINER, CONTENT_RENDER, CONTENT_PAGINATION_BUTTON,
  CONTENT_CARD, TEXT, CONTENT_CARD_TEMPLATE, IMAGE, BASIC_TEXT, CONTENT_FILTER_CONTAINER,
  CONTENT_FILTER, CONTENT_EMPTY_MESSAGE, CONTENT_LOADING, CONTENT_SEARCH
} from 'constants/widgetTypes';
import shortid from 'shortid';
import { PaletteContext } from '.';
import { WidgetPaletteFolders } from './multiWidgetFolderPalette';
import cx from 'classnames';
import _ from 'lodash';
import { Nav, Tab } from 'react-bootstrap';
import styles from './palette.module.scss';

export const ContentGridPalette = ({ editorSession, defaultParent }) => {
  const paletteContext = React.useContext(PaletteContext);

  const { palettes = [] } = paletteContext;

  const paletteData = palettes.find(item => item.type === 'ASSET_GRID');
  const defaultId = _.get(paletteData, 'defaultId', null);
  const brandkitId = _.get(paletteData, 'brandkitId', null);

  return (
    <Tab.Pane eventKey="ASSET_GRID" className={cx(styles.tabPane, styles.commonPalette)}>
      <WidgetPaletteFolders
        editorSession={editorSession}
        defaultParent={defaultParent}
        paletteId={brandkitId}
        type={'default'}
        paletteData={paletteData}
        defaultPaletteId={defaultId}
        typeName={'ASSET GRIDS'}
      />
    </Tab.Pane>
  )
}

export const contentGrid = [
  {
    id: 'template_1',
    name: 'template1',
    render: () => {
      return <img style={{ width: '100%', height: '100%' }} src="/images/assetcards/template1.png" alt="template1" />
    },
    data: {
      type: CONTENT,
      name: 'Content',
      properties: {
        "desktop": {
          "visible": true,
          "filters": false,
          "search": false,
          "layout": {
            "transform": {
              "translate": `50%, 0px`,
              "rotate": "0deg"
            }
          },
          "layoutStyle": {
            "type": "cleverstory.v2.content.layout.grid",
            "rowSpacing": "20",
            "columnSpacing": "20",
            "pagination": "load_more",
            "itemsPerPage": 3,
            "alignment": "center"
          },
          "stretched": true,
          "margin": 0,
          "background": null,
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "mobile": {
          "visible": true,
          "layout": {
            "transform": {
              "translate": `0px, 0px`,
              "rotate": "0deg"
            }
          },
          "search": false,
          "layoutStyle": null,
          "stretched": false,
          "margin": 0,
          "background": null,
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          },
          "filters": false
        }
      },
      content: { id: null, type: null, changes: null },
      widgets: [
        {
          type: CONTENT_FILTER,
          name: "Filter & Search",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 210px",
                  "rotate": "0deg"
                },
                "width": "100%",
                "height": "100px"
              },
              "stretched": false,
              "padding": 0,
              "scrollEffect": "NONE",
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              },
              "alignment": {
                "position": "center",
                "margin": null
              },
              "verticalAlignment": {
                "position": "center",
                "margin": null
              },
              "horizontalColumn": false,
              "columnReverse": false,
              "spacing": 20
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 20px",
                  "rotate": "0deg"
                },
                "width": "100%",
                "height": "auto"
              },
              "stretched": false,
              "padding": 0,
              "scrollEffect": null,
              "background": null,
              "alignment": {
                "position": "center",
                "margin": null
              },
              "verticalAlignment": {
                "position": "center",
                "margin": null
              },
              "horizontalColumn": false,
              "columnReverse": false,
              "spacing": 16
            }
          },
          widgets: [
            {
              type: CONTENT_SEARCH,
              name: "Search Container",
              properties: {
                "desktop": {
                  "visible": true,
                  "layout": {
                    "transform": {
                      "rotate": "0deg"
                    },
                    "width": "376px",
                    "height": "auto"
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "width": "0",
                    "radius": null,
                    "style": "all"
                  },
                  "placeholder": "Search",
                  "padding": 5,
                  "background": {
                    "type": "solid",
                    "r": 224,
                    "g": 224,
                    "b": 224,
                    "a": 1
                  },
                  "inputTextColor": {
                    "type": "solid",
                    "r": 0,
                    "g": 0,
                    "b": 0,
                    "a": 1
                  },
                  "placeholderColor": {
                    "type": "solid",
                    "r": 245,
                    "g": 245,
                    "b": 245,
                    "a": 1
                  },
                  "searchIconColor": {
                    "type": "solid",
                    "r": 0,
                    "g": 0,
                    "b": 0,
                    "a": 1
                  },
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 33,
                      "g": 33,
                      "b": 33,
                      "a": 1
                    }
                  },
                  "horizontalAlignment": {
                    "position": "center",
                    "margin": null
                  },
                  "buttonStyles": {
                    "regular": {
                      "font": {
                        "style": {
                          "bold": false,
                          "italic": false,
                          "underline": false
                        },
                        "fontSize": "14",
                        "fontFamily": null,
                        "lineSpacing": null,
                        "letterSpacing": null,
                        "color": {
                          "type": "solid",
                          "r": 255,
                          "g": 255,
                          "b": 255,
                          "a": 1
                        }
                      },
                      "background": {
                        "type": "solid",
                        "r": 117,
                        "g": 117,
                        "b": 117,
                        "a": 1
                      },
                      "border": {
                        "sides": null,
                        "color": {
                          "type": "solid",
                          "r": 255,
                          "g": 255,
                          "b": 255,
                          "a": 1
                        },
                        "width": "0",
                        "radius": {
                          "lock": false,
                          "topLeft": "0",
                          "topRight": "0",
                          "bottomLeft": "0",
                          "bottomRight": "0"
                        }
                      },
                      "shadow": {
                        "color": {
                          "type": "solid",
                          "r": 255,
                          "g": 255,
                          "b": 255,
                          "a": 1
                        },
                        "axes": {
                          "x": "0",
                          "y": "0",
                          "b": "0"
                        },
                        "show": false
                      }
                    },
                    "hover": {
                      "font": {
                        "style": {
                          "bold": false,
                          "italic": false,
                          "underline": false
                        },
                        "fontSize": "14",
                        "fontFamily": null,
                        "lineSpacing": null,
                        "letterSpacing": null,
                        "color": {
                          "type": "solid",
                          "r": 255,
                          "g": 255,
                          "b": 255,
                          "a": 1
                        }
                      },
                      "background": {
                        "type": "solid",
                        "r": 117,
                        "g": 117,
                        "b": 117,
                        "a": 1
                      },
                      "border": {
                        "sides": null,
                        "color": {
                          "type": "solid",
                          "r": 255,
                          "g": 255,
                          "b": 255,
                          "a": 1
                        },
                        "width": "0",
                        "radius": {
                          "lock": false,
                          "topLeft": "0",
                          "topRight": "0",
                          "bottomLeft": "0",
                          "bottomRight": "0"
                        }
                      },
                      "shadow": {
                        "color": {
                          "type": "solid",
                          "r": 255,
                          "g": 255,
                          "b": 255,
                          "a": 1
                        },
                        "axes": {
                          "x": "0",
                          "y": "0",
                          "b": "0"
                        },
                        "show": false
                      }
                    }
                  }
                },
                "mobile": {
                  "visible": true,
                  "layout": {
                    "transform": {
                      "rotate": "0deg"
                    },
                    "width": "100%",
                    "height": "auto"
                  },
                  "border": {
                    "sides": null,
                    "color": null,
                    "width": null,
                    "radius": null,
                    "style": null
                  },
                  "placeholder": null,
                  "padding": 0,
                  "background": null,
                  "inputTextColor": null,
                  "placeholderColor": null,
                  "searchIconColor": null,
                  "font": null,
                  "horizontalAlignment": null,
                  "buttonStyles": null
                }
              },
              content: null,
            },
            {
              type: CONTENT_FILTER_CONTAINER,
              name: "Filter Container",
              properties: {
                "desktop": {
                  "visible": true,
                  "layout": {
                    "transform": {
                      "rotate": "0deg"
                    },
                    "width": "auto",
                    "height": "auto"
                  },
                  "regular": {
                    "filterStyles": {
                      "font": {
                        "style": {
                          "bold": false,
                          "italic": false,
                          "underline": false
                        },
                        "fontSize": "14",
                        "fontFamily": null,
                        "lineSpacing": null,
                        "letterSpacing": null,
                        "color": {
                          "type": "solid",
                          "r": 0,
                          "g": 0,
                          "b": 0,
                          "a": 1
                        }
                      },
                      "background": {
                        "type": "solid",
                        "r": 255,
                        "g": 255,
                        "b": 255,
                        "a": 1
                      },
                      "border": {
                        "sides": null,
                        "color": {
                          "type": "solid",
                          "r": 0,
                          "g": 0,
                          "b": 0,
                          "a": 1
                        },
                        "width": "1",
                        "radius": {
                          "lock": false,
                          "topLeft": "4",
                          "topRight": "4",
                          "bottomLeft": "4",
                          "bottomRight": "4"
                        }
                      },
                      "shadow": null
                    },
                    "dropdownColor": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "dropdownBackground": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "dropdownBorder": {
                      "sides": null,
                      "color": {
                        "type": "solid",
                        "r": 255,
                        "g": 255,
                        "b": 255,
                        "a": 1
                      },
                      "width": "0",
                      "radius": {
                        "lock": false,
                        "topLeft": "0",
                        "topRight": "0",
                        "bottomLeft": "0",
                        "bottomRight": "0"
                      }
                    }
                  },
                  "hover": {
                    "filterStyles": {
                      "font": {
                        "style": {
                          "bold": false,
                          "italic": false,
                          "underline": false
                        },
                        "fontSize": "14",
                        "fontFamily": null,
                        "lineSpacing": null,
                        "letterSpacing": null,
                        "color": {
                          "type": "solid",
                          "r": 0,
                          "g": 0,
                          "b": 0,
                          "a": 1
                        }
                      },
                      "background": {
                        "type": "solid",
                        "r": 255,
                        "g": 255,
                        "b": 255,
                        "a": 1
                      },
                      "border": {
                        "sides": null,
                        "color": {
                          "type": "solid",
                          "r": 0,
                          "g": 0,
                          "b": 0,
                          "a": 1
                        },
                        "width": "1",
                        "radius": {
                          "lock": false,
                          "topLeft": "4",
                          "topRight": "4",
                          "bottomLeft": "4",
                          "bottomRight": "4"
                        }
                      },
                      "shadow": null
                    },
                    "dropdownColor": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "dropdownBackground": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "dropdownBorder": {
                      "sides": null,
                      "color": {
                        "type": "solid",
                        "r": 0,
                        "g": 0,
                        "b": 0,
                        "a": 1
                      },
                      "width": "1",
                      "radius": {
                        "lock": false,
                        "topLeft": "4",
                        "topRight": "4",
                        "bottomLeft": "4",
                        "bottomRight": "4"
                      }
                    }
                  },
                  "alignment": {
                    "position": "center",
                    "margin": null
                  },
                  "trayAlignment": {
                    "position": "center",
                    "margin": null
                  },
                  "padding": 10,
                  "itemHorizontalPadding": 20,
                  "itemVerticalPadding": 8,
                  "trayBackground": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "animation": null,
                  "horizontalAlignment": {
                    "position": "center",
                    "margin": null
                  }
                },
                "mobile": {
                  "visible": true,
                  "layout": {
                    "transform": {
                      "rotate": "0deg"
                    },
                    "width": "100%",
                    "height": "auto"
                  },
                  "regular": {
                    "filterStyles": {
                      "font": {
                        "style": {
                          "bold": false,
                          "italic": false,
                          "underline": false
                        },
                        "fontSize": "14",
                        "fontFamily": null,
                        "lineSpacing": null,
                        "letterSpacing": null,
                        "color": {
                          "type": "solid",
                          "r": 255,
                          "g": 255,
                          "b": 255,
                          "a": 1
                        }
                      },
                      "background": {
                        "type": "solid",
                        "r": 0,
                        "g": 0,
                        "b": 0,
                        "a": 1
                      },
                      "border": {
                        "sides": null,
                        "color": {
                          "type": "solid",
                          "r": 255,
                          "g": 255,
                          "b": 255,
                          "a": 1
                        },
                        "width": "0",
                        "radius": {
                          "lock": false,
                          "topLeft": "0",
                          "topRight": "0",
                          "bottomLeft": "0",
                          "bottomRight": "0"
                        }
                      },
                      "shadow": null
                    },
                    "dropdownColor": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "dropdownBackground": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "dropdownBorder": {
                      "sides": null,
                      "color": {
                        "type": "solid",
                        "r": 255,
                        "g": 255,
                        "b": 255,
                        "a": 1
                      },
                      "width": "0",
                      "radius": {
                        "lock": false,
                        "topLeft": "0",
                        "topRight": "0",
                        "bottomLeft": "0",
                        "bottomRight": "0"
                      }
                    }
                  },
                  "hover": {
                    "filterStyles": {
                      "font": {
                        "style": {
                          "bold": false,
                          "italic": false,
                          "underline": false
                        },
                        "fontSize": "14",
                        "fontFamily": null,
                        "lineSpacing": null,
                        "letterSpacing": null,
                        "color": {
                          "type": "solid",
                          "r": 0,
                          "g": 0,
                          "b": 0,
                          "a": 1
                        }
                      },
                      "background": {
                        "type": "solid",
                        "r": 255,
                        "g": 255,
                        "b": 255,
                        "a": 1
                      },
                      "border": {
                        "sides": null,
                        "color": {
                          "type": "solid",
                          "r": 255,
                          "g": 255,
                          "b": 255,
                          "a": 1
                        },
                        "width": "0",
                        "radius": {
                          "lock": false,
                          "topLeft": "0",
                          "topRight": "0",
                          "bottomLeft": "0",
                          "bottomRight": "0"
                        }
                      },
                      "shadow": null
                    },
                    "dropdownColor": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "dropdownBackground": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "dropdownBorder": {
                      "sides": null,
                      "color": {
                        "type": "solid",
                        "r": 255,
                        "g": 255,
                        "b": 255,
                        "a": 1
                      },
                      "width": "0",
                      "radius": {
                        "lock": false,
                        "topLeft": "0",
                        "topRight": "0",
                        "bottomLeft": "0",
                        "bottomRight": "0"
                      }
                    }
                  },
                  "alignment": {
                    "position": "center",
                    "margin": null
                  },
                  "trayAlignment": {
                    "position": "center",
                    "margin": null
                  },
                  "padding": 0,
                  "itemHorizontalPadding": 0,
                  "itemVerticalPadding": 0,
                  "trayBackground": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "animation": null,
                  "horizontalAlignment": null
                }
              },
              content: []
            }
          ]
        },
        {
          type: CONTENT_LOADING,
          name: "Loading",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px",
                  "rotate": "0deg"
                },
                "width": null,
                "height": "400px"
              },
              "background": null,
              "border": null
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px",
                  "rotate": "0deg"
                },
                "width": null,
                "height": "600px"
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              },
              "border": null
            }
          },
        },
        {
          type: CONTENT_EMPTY_MESSAGE,
          name: "No Result",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px",
                  "rotate": "0deg"
                },
                "width": null,
                "height": "400px"
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              },
              "border": null
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px",
                  "rotate": "0deg"
                },
                "width": null,
                "height": "600px"
              },
              "background": null,
              "border": null
            }
          }
        },
        {
          type: CONTENT_PAGINATION_BUTTON,
          name: "Pagination Button",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px",
                  "rotate": "0deg"
                },
                "width": "200px",
                "height": "40px"
              },
              "regular": {
                "font": {
                  "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false
                  },
                  "fontSize": "14",
                  "fontFamily": "Montserrat,sans-serif",
                  "lineSpacing": null,
                  "letterSpacing": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  }
                },
                "background": {
                  "type": "solid",
                  "r": 67,
                  "g": 108,
                  "b": 179,
                  "a": 1
                },
                "border": {
                  "sides": null,
                  "color": null,
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                },
                "shadow": {
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "axes": {
                    "x": "0",
                    "y": "0",
                    "b": "0"
                  },
                  "show": false
                }
              },
              "hover": {
                "font": {
                  "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false
                  },
                  "fontSize": "14",
                  "fontFamily": null,
                  "lineSpacing": null,
                  "letterSpacing": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  }
                },
                "background": {
                  "type": "solid",
                  "r": 67,
                  "g": 108,
                  "b": 179,
                  "a": 1
                },
                "border": {
                  "sides": null,
                  "color": null,
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                },
                "shadow": {
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "axes": {
                    "x": "0",
                    "y": "0",
                    "b": "0"
                  },
                  "show": false
                }
              },
              "alignment": null,
              "animation": null
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px",
                  "rotate": "0deg"
                },
                "width": "200px",
                "height": "40px"
              },
              "regular": {
                "font": {
                  "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false
                  },
                  "fontSize": "14",
                  "fontFamily": null,
                  "lineSpacing": null,
                  "letterSpacing": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  }
                },
                "background": {
                  "type": "solid",
                  "r": 67,
                  "g": 108,
                  "b": 179,
                  "a": 1
                },
                "border": {
                  "sides": null,
                  "color": null,
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                },
                "shadow": null
              },
              "hover": {
                "font": {
                  "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false
                  },
                  "fontSize": "14",
                  "fontFamily": null,
                  "lineSpacing": null,
                  "letterSpacing": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  }
                },
                "background": {
                  "type": "solid",
                  "r": 67,
                  "g": 108,
                  "b": 179,
                  "a": 1
                },
                "border": {
                  "sides": null,
                  "color": null,
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                },
                "shadow": null
              },
              "alignment": null,
              "animation": null
            }
          },
          content: 'Load More'
        }, {
          name: "Asset Card",
          type: CONTENT_CARD_TEMPLATE,
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px, 0px",
                  "rotate": "0deg"
                },
                "width": "300px",
                "height": "300px"
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              },
              "border": {
                "sides": null,
                "color": {
                  "type": "solid",
                  "r": 242,
                  "g": 242,
                  "b": 242,
                  "a": 1
                },
                "width": "1",
                "radius": {
                  "lock": true,
                  "topLeft": "5",
                  "topRight": "5",
                  "bottomLeft": "5",
                  "bottomRight": "5"
                }
              },
              "hoverStyle": "move_up_with_shadow",
              "shadow": {
                "color": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "axes": {
                  "x": "0",
                  "y": "0",
                  "b": "0"
                },
                "show": false
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px, 0px",
                  "rotate": "0deg"
                },
                "width": "335px",
                "height": "335px"
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              },
              "border": {
                "sides": null,
                "color": {
                  "type": "solid",
                  "r": 242,
                  "g": 242,
                  "b": 242,
                  "a": 1
                },
                "width": "1",
                "radius": {
                  "lock": true,
                  "topLeft": "5",
                  "topRight": "5",
                  "bottomLeft": "5",
                  "bottomRight": "5"
                }
              },
              "hoverStyle": null,
              "shadow": {
                "color": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "axes": {
                  "x": "0",
                  "y": "0",
                  "b": "0"
                },
                "show": false
              }
            }
          },
          widgets: [{
            type: IMAGE,
            name: "Image",
            parameter: 'icon',
            properties: {
              "desktop": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "0px, 0px",
                    "rotate": "0deg"
                  },
                  "width": "298px",
                  "height": "154px"
                },
                "crop": null,
                "alt": null,
                "animation": null,
                "border": null,
                "position": null,
                "shadow": null
              },
              "mobile": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "0px, 0px",
                    "rotate": "0deg"
                  },
                  "width": "335px",
                  "height": "189px"
                },
                "crop": null,
                "alt": null,
                "animation": null,
                "border": null,
                "position": null,
                "shadow": null
              }
            },
            content: null
          }, {
            type: BASIC_TEXT,
            name: "Name",
            parameter: "name",
            properties: {
              "desktop": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "20px, 175px",
                    "rotate": "0deg"
                  },
                  "width": "260px",
                  "height": "50px"
                },
                "font": {
                  "style": null,
                  "fontSize": "18",
                  "fontFamily": "Montserrat,sans-serif",
                  "lineSpacing": "1.2",
                  "letterSpacing": "0",
                  "color": null
                },
                "alignment": "left",
                "background": null,
                "animation": null
              },
              "mobile": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "20px, 210px",
                    "rotate": "0deg"
                  },
                  "width": "295px",
                  "height": "50px"
                },
                "font": {
                  "style": null,
                  "fontSize": "18",
                  "fontFamily": null,
                  "lineSpacing": "1.2",
                  "letterSpacing": "0",
                  "color": null
                },
                "alignment": "left",
                "background": null,
                "animation": null
              }
            },
            content: 'Name'
          }, {
            type: 'cleverstory.v2.widgets.button',
            name: 'Button',
            parameter: 'cta',
            properties: {
              "desktop": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "20px,255px",
                    "rotate": "0deg",
                    "scale": "1,1"
                  },
                  "width": "123px",
                  "height": "37px"
                },
                "regular": {
                  "font": {
                    "style": {
                      "bold": true,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 101,
                      "g": 101,
                      "b": 101,
                      "a": 1
                    }
                  },
                  "background": null,
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "hover": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    }
                  },
                  "background": null,
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "alignment": {
                  "position": "left",
                  "margin": "0"
                },
                "animation": null
              },
              "mobile": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "20px,290px",
                    "rotate": "0deg"
                  },
                  "width": "123px",
                  "height": "37px"
                },
                "regular": {
                  "font": {
                    "style": {
                      "bold": true,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 101,
                      "g": 101,
                      "b": 101,
                      "a": 1
                    }
                  },
                  "background": null,
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "hover": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    }
                  },
                  "background": null,
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "alignment": {
                  "position": "left",
                  "margin": "0"
                },
                "animation": null
              }
            },
            content: 'Read More →'
          }, {
            type: 'cleverstory.v2.widgets.rectangle',
            name: 'Shape',
            properties: {
              "desktop": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "215px,264px",
                    "rotate": "0deg",
                    "scale": "1,1"
                  },
                  "width": "86px",
                  "height": "20px"
                },
                "background": {
                  "type": "solid",
                  "r": 100,
                  "g": 100,
                  "b": 100,
                  "a": 1
                },
                "border": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "3",
                    "topRight": "0",
                    "bottomLeft": "3",
                    "bottomRight": "0"
                  }
                },
                "animation": null,
                "shadow": null
              },
              "mobile": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "250px,299px",
                    "rotate": "0deg",
                    "scale": "1,1"
                  },
                  "width": "86px",
                  "height": "20px"
                },
                "background": {
                  "type": "solid",
                  "r": 100,
                  "g": 100,
                  "b": 100,
                  "a": 1
                },
                "border": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "3",
                    "topRight": "0",
                    "bottomLeft": "3",
                    "bottomRight": "0"
                  }
                },
                "animation": null,
                "shadow": null
              }
            },
            content: null
          },
          {
            type: 'cleverstory.v2.widgets.text.basic',
            name: 'Type',
            parameter: 'contentType',
            properties: {
              "desktop": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "215px,268px",
                    "rotate": "0deg",
                    "scale": "1,1"
                  },
                  "width": "84px",
                  "height": "24px"
                },
                "font": {
                  "style": {
                    "bold": true,
                    "italic": false,
                    "underline": false
                  },
                  "fontSize": "10",
                  "fontFamily": "Montserrat,sans-serif",
                  "lineSpacing": "1.2",
                  "letterSpacing": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  }
                },
                "alignment": "center",
                "background": null,
                "animation": null
              },
              "mobile": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "250px,302px",
                    "rotate": "0deg",
                    "scale": "1,1"
                  },
                  "width": "84px",
                  "height": "24px"
                },
                "font": {
                  "style": null,
                  "fontSize": "10",
                  "fontFamily": null,
                  "lineSpacing": null,
                  "letterSpacing": null,
                  "color": null
                },
                "alignment": "center",
                "background": null,
                "animation": null
              }
            },
            content: 'Type'
          }]
        }
      ]
    }
  },
]
